/* File : src/App.js */
import React from 'react';
import AppRoutes from './routes';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import { PaymentProvider } from './contexts/PaymentContext';
import { CreatorProvider } from './contexts/CreatorContext';
import './App.css';

/**
 * Composant principal de l'application
 * Encapsule les routes dans les providers de contexte
 * 
 * ORDRE DES PROVIDERS (important):
 * 1. AuthProvider - Authentification globale
 * 2. DataProvider - Données globales
 * 3. PaymentProvider - Gestion des paiements (NOUVEAU)
 * 4. CreatorProvider - Tracking des créateurs (NOUVEAU)
 */
function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <PaymentProvider>
          <CreatorProvider>
            <div className="app">
              <AppRoutes />
            </div>
          </CreatorProvider>
        </PaymentProvider>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;